(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockCountDataItem', {
        templateUrl: 'views/components/views/stockCountDataItem/stockCountDataItem.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'inventoryScanService', 'stockCountDataItemService', function ($stateParams, stateService, utilityService, modalService, translateService, inventoryScanService, stockCountDataItemService) {
            
            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockCountDataItemKeyno = $stateParams.stockcountdataitem_keyno;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                edit: {},
                itemsListLastScans: [],
                lockedOkAndScanAgain: false,
                lockedConfirm: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await stockCountDataItemService.getEdit({
                    stockcountdataitem_keyno: stockCountDataItemKeyno,
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                return loadLastScans();
            }
            
            async function loadLastScans() {
                if (utilityService.validateParmsValue(vm.model.edit.stockcount_keyno) !== true) return;
                
                return vm.model.itemsListLastScans = await inventoryScanService.listLastScans({ stockcount_keyno: vm.model.edit.stockcount_keyno });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region SAVE BUTTON FUNCTION

            function saveChanges() {
                if (vm.model.edit.scan_again === '1') {
                    stockCountDataItemService.saveObj(vm.model.edit).then(() => {
                        vm.model.lockedOkAndScanAgain = false;
                        stateService.back('/' + 'inventoryscan');
                    }, () => vm.model.lockedOkAndScanAgain = false);
                } else {
                    stockCountDataItemService.saveObj(vm.model.edit).then(function () {
                        vm.model.lockedConfirm = false;
                        stateService.back('/' + 'inventoryscan');
                    }, () => vm.model.lockedConfirm = false);
                }
            }
            
            vm.okAndScanAgain = function () {
                vm.model.lockedOkAndScanAgain = true;
                vm.model.edit.scan_again = '1';
                
                saveChanges();
            };
            
            vm.confirmChanges = function () {
                vm.model.lockedConfirm = true;
                
                saveChanges();
            };

            // #endregion SAVE BUTTON FUNCTION

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(function () {
                    stockCountDataItemService.deleteItem(vm.model.edit).then(function () {
                        vm.model.lockedDelete = false;
                        stateService.back('/' + 'inventoryscan');
                    }, function () {
                        vm.model.lockedDelete = false;
                    });
                }, function () {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
